export default __webpack_public_path__ + "static/media/calloutRect.ca4e01b0.svg";